module.exports = __webpack_public_path__ + "static/media/tlyfeWhite.e8c1839f.png";